import React, { Component } from "react";
import { connect } from 'react-redux';
import { FormGroup, FormControl, Form } from "react-bootstrap";
import { Auth } from "aws-amplify";
import LoaderButton from "../../../components/LoaderButton";

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.session.isAuthenticated,
    user: state.session.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleLoginPanel: () => {
      dispatch({ type: 'HIDE_LOGIN_PANEL' });
    },
    userHasAuthenticated: (user) => {
      console.log('authenticating...', user);
      dispatch({ type: 'LOGIN_USER_SUCCESS', user });
    }
  }
}

class Register extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: "",
      password: "",
      name: "",
      preferred_username: "",
      confirmPassword: "",
      confirmationCode: "",
      newUser: null
    };
  }

  validateForm() {
    return (
      this.state.email.length > 0 &&
      this.state.password.length > 0 &&
      this.state.password === this.state.confirmPassword
    );
  }

  validateConfirmationForm() {
    return this.state.confirmationCode.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = async event => {
    event.preventDefault();

    // --user-attributes Name=preferred_username,Value=admin Name=name,Value=adam

    try {
      // let restOfAttrs = [
      //   "Name=preferred_username,Value=" + this.state.preferred_username,
      //   "Name=name,Value=" + this.state.name
      // ];
      const newUser = await Auth.signUp({
        username: this.state.email,
        password: this.state.password,
        attributes: {
          preferred_username: this.state.preferred_username,
          name: this.state.name
        }
      });

      this.setState({ newUser });

    } catch (e) {
      alert(e.message);

    };

    this.setState({ isLoading: false });
  }

  handleConfirmationSubmit = async event => {
    event.preventDefault();
    this.setState({ isLoading: true });

    try {
      await Auth.confirmSignUp(this.state.email, this.state.confirmationCode);
      await Auth.signIn(this.state.email, this.state.password);

      await Auth.currentUserInfo().then(result => {
        this.setState({ isLoading: false });
        this.props.userHasAuthenticated(result);
        this.props.toggleLoginPanel();
      });
    } catch (e) {
      alert(e.message);
      this.setState({ isLoading: false });
    }
  }

  renderConfirmationForm() {
    return (
      <form onSubmit={this.handleConfirmationSubmit}>
        <FormGroup controlId="confirmationCode" bsSize="large">
          <span className="fas fa-key" />
          <FormControl
            autoFocus
            type="tel"
            placeholder="Confirmation Code"
            value={this.state.confirmationCode}
            onChange={this.handleChange}
          />
          <Form.HelpBlock>Please check your email for the code.</Form.HelpBlock>
        </FormGroup>
        <LoaderButton
          block
          bsSize="large"
          disabled={!this.validateConfirmationForm()}
          type="submit"
          isLoading={this.state.isLoading}
          text="Verify"
          loadingText="Verifying…"
        />
      </form>
    );
  }

  renderForm() {
    return (
      <form onSubmit={this.handleSubmit}>
        <FormGroup controlId="name" bsSize="large">
          <span className="fas fa-user min-width-3 text-center mr-2" />
          <FormControl
            autoFocus
            type="text"
            placeholder="Name"
            value={this.state.name}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="preferred_username" bsSize="large">
          <span className="fas fa-user min-width-3 text-center mr-2" />
          <FormControl
            autoFocus
            type="text"
            placeholder="Username"
            value={this.state.preferred_username}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="email" bsSize="large">
          <span className="fas fa-envelope" />
          <FormControl
            autoFocus
            type="email"
            placeholder="Email"
            value={this.state.email}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="password" bsSize="large">
          <span className="fas fa-unlock" />
          <FormControl
            value={this.state.password}
            onChange={this.handleChange}
            type="password"
            placeholder="Password"
          />
        </FormGroup>
        <FormGroup controlId="confirmPassword" bsSize="large">
          <span className="fas fa-lock" />
          <FormControl
            value={this.state.confirmPassword}
            onChange={this.handleChange}
            type="password"
            placeholder="Confirm Password"
          />
        </FormGroup>
        <LoaderButton
          block
          bsSize="large"
          disabled={!this.validateForm()}
          type="submit"
          isLoading={this.state.isLoading}
          text="Register"
          loadingText="Registering…"
        />
      </form>
    );
  }

  // we are conditionally rendering two forms based on if we have a user object or not for confirmation code.
  render() {
    return (
      <div className="register">
        {this.state.newUser === null
          ? this.renderForm()
          : this.renderConfirmationForm()}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Register);



// WEBPACK FOOTER //
// ./src/containers/auth/views/Register.js